import { cn as e } from "../../lib/utils.es.js";
import "react";
import { CheckIcon as t } from "lucide-react";
import { jsx as n } from "react/jsx-runtime";
import * as r from "@radix-ui/react-checkbox";
// libs/ui-lib/src/components/ui/checkbox.tsx
function i({ className: i, ...a }) {
	return /* @__PURE__ */ n(r.Root, {
		"data-slot": "checkbox",
		className: e("peer border-input dark:bg-input/30 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground dark:data-[state=checked]:bg-primary data-[state=checked]:border-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive size-4 shrink-0 rounded-[4px] border shadow-xs transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50", i),
		...a,
		children: /* @__PURE__ */ n(r.Indicator, {
			"data-slot": "checkbox-indicator",
			className: "flex items-center justify-center text-current transition-none",
			children: /* @__PURE__ */ n(t, { className: "size-3.5" })
		})
	});
}
export { i as Checkbox };
